import { Link } from "react-router-dom";
import { Facebook, Instagram, Twitter } from "@mui/icons-material";
import { Grid, Container, Box, Typography, IconButton } from "@mui/material";

export const Footer = () => {
  return (
    <footer>
      <Container maxWidth="xl" sx={{ mb: 5, mt: 10 }}>
        <Grid container spacing={5}>
          <Grid item md={6}>
            <Link to="/">
              <img
                style={{ height: "2.5rem", width: "auto" }}
                src="/images/logo.png"
                alt="Logo"
              />
            </Link>
            <br />
            <br />
            <br />
            <Typography>
              Uff Yeh is a hindi news channel in India. Uffyeh.com is a growing
              hindi news website that focuses on delivering latest national and
              international news www.hindpharma.com about business, politics,
              sports, entertainment, technology, lifestyle, astrology and more
              in hindi language.
            </Typography>
            <br />
            <br />
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography>Follow us on :</Typography>
              &nbsp; &nbsp;
              <IconButton onClick={() => alert("Clicked")} color="error">
                <Facebook />
              </IconButton>
              &nbsp; &nbsp;
              <IconButton onClick={() => alert("Clicked")} color="error">
                <Instagram />
              </IconButton>
              &nbsp; &nbsp;
              <IconButton onClick={() => alert("Clicked")} color="error">
                <Twitter />
              </IconButton>
            </Box>
          </Grid>
          <Grid item md={3}>
            <Box sx={{ textAlign: "center" }}>
              <Typography>
                <b>Company</b>
              </Typography>
              <br />
              <br />
              <Link to="/about">
                <Typography sx={{ mb: 1 }}>About Us</Typography>
              </Link>
              <Link to="/contact">
                <Typography sx={{ mb: 1 }}>Contact Us</Typography>
              </Link>
            </Box>
          </Grid>
          <Grid item md={3}>
            <Box sx={{ textAlign: "center" }}>
              <Typography>
                <b>Quick Links</b>
              </Typography>
              <br />
              <br />
              <Link to="/shows">
                <Typography sx={{ mb: 1 }}>कानून के खिलाफ</Typography>
              </Link>
              <Link to="/movies">
                <Typography sx={{ mb: 1 }}>खबर भारत</Typography>
              </Link>
              <Link to="/news">
                <Typography sx={{ mb: 1 }}>खबर लपक</Typography>
              </Link>
              <Link to="/kids">
                <Typography sx={{ mb: 1 }}>दम से बोलूंगा</Typography>
              </Link>
              <Link to="/music">
                <Typography sx={{ mb: 1 }}>बिंदास आवाज</Typography>
              </Link>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <hr />
      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography>
          <b>Copyright © All Rights Reserved</b>
        </Typography>
      </Box>
    </footer>
  );
};
